import script from "./ModalMasInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalMasInfo.vue?vue&type=script&setup=true&lang=js"

import "./ModalMasInfo.vue?vue&type=style&index=0&id=51680d70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51680d70"]])

export default __exports__